module.exports = __webpack_public_path__ + "img/TH.3eb69768.svg";